import * as React from 'react';

export type SiteContainerElement = 'div' | 'header' | 'footer' | 'section' | 'main';

export interface SiteContainerProps {
  as?: SiteContainerElement;
  className?: string;
  children: React.ReactNode;
}

const BASE_CLASSES = [
  'max-w-site',
  'mx-auto',
  'px-grid-margin-mobile',
  'desktop:px-grid-margin-desktop',
] as const;

// SiteContainer deliberately does not spread arbitrary HTML attributes. The
// Storyblok semantic invariant requires storyblokEditable(blok) to sit on each
// block's semantic root, not on this container. Omitting ...rest mechanically
// prevents that attribute set from migrating onto SiteContainer.
export const SiteContainer: React.FC<SiteContainerProps> = ({
  as = 'div',
  className,
  children,
}) => {
  const composed = [...BASE_CLASSES, className].filter(Boolean).join(' ');
  return React.createElement(as, { className: composed }, children);
};
